import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAccountDataQuery } from 'queries/account';
import { getCurrentUserProfileState } from '../index';
/**
 * @deprecated Returns a new object on every call. Use `useCurrentUserProfileV2`.
 */ export const useCurrentUserProfile = ()=>{
    const { isLoading } = useAccountDataQuery();
    const state = useSelector(getCurrentUserProfileState);
    return {
        ...state,
        loading: isLoading
    };
};
export const useCurrentUserProfileV2 = ()=>{
    const { isLoading } = useAccountDataQuery();
    const state = useSelector(getCurrentUserProfileState);
    return useMemo(()=>({
            ...state,
            loading: isLoading
        }), [
        state,
        isLoading
    ]);
};
